import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',

    '& .react-pdf__Page': {
      margin: '1rem',
      maxWidth: 'calc(100% - 2rem)',
      boxShadow: '0 0 8px rgba(0, 0, 0, 0.5)'
    },

    '& .react-pdf__Page canvas': {
      width: '100% !important',
      maxWidth: '100%',
      height: 'auto !important'
    }
  }
}))

export default useStyles
